<template>
  <div class="guide-page">
    <div class="content">
      <h2>玩家攻略</h2>
    </div>
    <div class="menu_content">
      <div v-for="(guide, index) in guideList" :key="index" class="menu_ul">
        <div class="spec">
          <img src="../../assets/img/home/family.png" alt="" />
          <h3>{{ guide.title }}</h3>
        </div>
        <p>
          {{ guide.content }}
        </p>
        <div class="guide-meta">
          <span class="author">作者：{{ guide.author }}</span>
          <span class="date">{{ guide.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Guide',
  data() {
    return {
      guideList: [
        {
          title: '新手快速升级指南',
          author: '老玩家',
          date: '2024-03-20',
          content: '本攻略将详细介绍新手如何快速升级，包括任务选择、练级地点推荐等内容。'
        },
        {
          title: '家族系统详解',
          author: '游戏达人',
          date: '2024-03-19',
          content: '全面解析家族系统的各项功能，帮助玩家更好地建设和管理家族。'
        },
        {
          title: '装备强化技巧',
          author: '技术流',
          date: '2024-03-18',
          content: '分享装备强化的实用技巧，帮助玩家提升装备属性。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.guide-page {
  padding: 20px;
}

.content h2 {
  font-weight: 800;
  color: #000000;
  text-align: center;
}

.menu_content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1%;
}

.menu_ul {
  flex-basis: 49%;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.menu_ul h3 {
  font-weight: 600;
  color: #494f51;
  line-height: 36px;
  margin-left: 6px;
}

.menu_ul img {
  max-width: 36px;
}

.spec {
  display: flex;
  align-items: center;
}

.menu_ul p {
  font-size: 14px;
  font-weight: 400;
  color: #919ca8;
  line-height: 24px;
  margin-top: 10px;
}

.guide-meta {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .menu_ul {
    flex-basis: 99%;
  }
}
</style> 